import PropTypes from "prop-types";
import React from "react";

import { Section } from "@swa-ui/core";
import { RadioButtonFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PlacementInfoLabel } from "../PlacementInfoLabel";
import styles from "./WheelchairAssistanceFormField.module.scss";
import {
  WHEELCHAIR_ASSISTANCE_OPTIONS,
  WHEELCHAIR_ASSISTANCE_SCHEMA_FIELD_NAME,
} from "./WheelchairAssistanceFormField.schema";

export const WheelchairAssistanceFormField = (props) => {
  const { wheelchairAssistanceFieldName = WHEELCHAIR_ASSISTANCE_SCHEMA_FIELD_NAME } = props;

  return (
    <Section {...getSectionProps()}>
      <RadioButtonFormField {...getRadioButtonFormFieldProps()} />
    </Section>
  );

  function getSectionProps() {
    return {
      headingProps: {
        bottomSpacing: "small",
        children: i18n("WheelchairAssistanceFormField__HEADER"),
        headingLevel: 2,
        styleLevel: 5,
        topSpacing: "medium",
      },
    };
  }
  function getRadioButtonFormFieldProps() {
    return {
      componentProps: {
        ariaLiveInput: (name, index, length) =>
          `${i18n("WheelchairAssistanceFormField__RADIO_BUTTON_ARIA_LIVE", {
            index,
            length,
            name,
          })}`,
        className: styles.radioGroup,
        direction: "column",
        radioButtonInfoList: [
          {
            label: i18n("WheelchairAssistanceFormField__NO_WHEELCHAIR_ASSISTANCE"),
            value: WHEELCHAIR_ASSISTANCE_OPTIONS.NO_ASSISTANCE,
          },
          {
            label: renderRadioLabel(
              "WheelchairAssistanceFormField__GATE_ASSISTANCE",
              "disabilityOptionWheelchairAssistanceNeeded"
            ),
            value: WHEELCHAIR_ASSISTANCE_OPTIONS.GATE_ASSISTANCE,
          },
          {
            label: renderRadioLabel(
              "WheelchairAssistanceFormField__AIRCRAFT_SEAT_ASSISTANCE",
              "disabilityOptionWheelchairAssistanceNeedLift"
            ),
            value: WHEELCHAIR_ASSISTANCE_OPTIONS.AIRCRAFT_SEAT_ASSISTANCE,
          },
        ],
      },
      hideBottomSection: true,
      name: wheelchairAssistanceFieldName,
    };
  }

  function renderRadioLabel(label, placementId) {
    return <PlacementInfoLabel label={label} placementId={placementId} />;
  }
};

export const wheelchairAssistanceFormFieldPropTypes = {
  /** Field name for wheel chair assistance radio group. */
  wheelchairAssistanceFieldName: PropTypes.string,
};

WheelchairAssistanceFormField.propTypes = wheelchairAssistanceFormFieldPropTypes;
